"use client";

import useSWR from "swr";

type AdminCheckResponse = {
  ok: boolean;
  isAdmin: boolean;
};

const fetcher = async (url: string): Promise<AdminCheckResponse> => {
  const response = await fetch(url);
  return response.json();
};

/**
 * Check if the current user is an admin
 * Returns { isAdmin: boolean, isLoading: boolean }
 */
export function useIsAdmin() {
  const { data, isLoading } = useSWR<AdminCheckResponse>(
    "/api/admin/check",
    fetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      dedupingInterval: 5 * 60 * 1000, // Cache for 5 minutes
    },
  );

  return {
    isAdmin: data?.isAdmin ?? false,
    isLoading,
  };
}
